import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon, CheckIcon, XIcon } from 'lucide-react';
import { beforePawsy, withPawsy } from '../data/content';
import { Heading, Section } from './Primitives';
export function Transformation() {
  return <Section className="bg-white" ariaLabel="Before and after Pawsy" data-id="element-228" data-mp="mo8v6tcf7f4q">
      <div className="mx-auto max-w-xl text-center" data-id="element-229" data-mp="rm0jldduwj46">
        <Heading data-id="element-230" data-mp="wkk7hjc0g4z6">From guessing to knowing.</Heading>
      </div>

      <div className="mx-auto mt-7 grid max-w-3xl items-stretch gap-3.5 lg:grid-cols-[1fr_auto_1fr] lg:gap-4" data-id="element-231" data-mp="wk2504yr8uit">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="rounded-2xl border border-orangey-100 bg-cream p-5" data-id="element-232" data-mp="11hapic7dlan8">
          <p className="font-mono text-[0.68rem] font-semibold uppercase tracking-[0.16em] text-ink-400" data-id="element-233" data-mp="1f8p9al93xfvc">
            Before Pawsy
          </p>
          <ul className="mt-4 space-y-3" data-id="element-234" data-mp="1c6a5m6oxgj8u">
            {beforePawsy.map(item => <li key={item} className="flex items-start gap-2.5 text-ink-500" data-id="element-235" data-mp="176fgo8opq3qf">
                <XIcon className="mt-1 h-4 w-4 shrink-0 text-coral" aria-hidden="true" data-id="element-236" data-mp="135c17naku9pq" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="flex items-center justify-center" aria-hidden="true" data-id="element-237" data-mp="y8bvjdhn38z5">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-orangey-500 text-white shadow-lift lg:rotate-[-90deg]" data-id="element-238" data-mp="1uw00suwlr71a">
            <ArrowDownIcon className="h-5 w-5" data-id="element-239" data-mp="1m47t2ryyqc0e" />
          </span>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.4,
        delay: 0.1,
        ease: 'easeOut'
      }} className="rounded-2xl border border-orangey-200 bg-orangey-50 p-5 shadow-soft" data-id="element-240" data-mp="1m23f1h7cnwme">
          <p className="font-mono text-[0.68rem] font-semibold uppercase tracking-[0.16em] text-orangey-700" data-id="element-241" data-mp="2sqary1er64n8">
            With Pawsy
          </p>
          <ul className="mt-4 space-y-3" data-id="element-242" data-mp="2xom109x84b4e">
            {withPawsy.map(item => <li key={item} className="flex items-start gap-2.5 font-medium text-ink-700" data-id="element-243" data-mp="2jwnv07yt6vcg">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-safe" aria-hidden="true" data-id="element-244" data-mp="2ny973r3ir5ll" />
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </Section>;
}